// src/frontend/pages/ContactPage.jsx
import React, { useState } from "react";
import {
    Typography,
    Box,
    Grid,
    TextField,
    Button,
    Paper,
    Alert
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export default function ContactPage() {

    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        message: ""
    });

    const [success, setSuccess] = useState(false);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // später hier API call
        console.log(form);

        setSuccess(true);

        setForm({
            name: "",
            email: "",
            phone: "",
            message: ""
        });
    };

    return (
        <Box>

            <Typography variant="h4" sx={{ fontWeight: 700, mb: 4 }}>
                Kontakt
            </Typography>

            <Grid container spacing={4}>

                {/* Formular */}
                <Grid item xs={12} md={7}>
                    <Paper sx={{ p: 4 }}>

                        {success && (
                            <Alert severity="success" sx={{ mb: 3 }}>
                                Vielen Dank! Ihre Nachricht wurde gesendet.
                            </Alert>
                        )}

                        <Box
                            component="form"
                            onSubmit={handleSubmit}
                        >

                            <Grid container spacing={2}>

                                <Grid item xs={12}>
                                    <TextField
                                        label="Name"
                                        name="name"
                                        value={form.name}
                                        onChange={handleChange}
                                        fullWidth
                                        required
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="E-Mail"
                                        name="email"
                                        type="email"
                                        value={form.email}
                                        onChange={handleChange}
                                        fullWidth
                                        required
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Telefon"
                                        name="phone"
                                        value={form.phone}
                                        onChange={handleChange}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        label="Nachricht"
                                        name="message"
                                        value={form.message}
                                        onChange={handleChange}
                                        multiline
                                        rows={5}
                                        fullWidth
                                        required
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        disableElevation
                                        endIcon={<ArrowForwardIcon sx={{ fontSize: "16px !important", transition: "transform 0.2s ease" }} />}
                                        sx={{
                                            background: "linear-gradient(135deg, var(--domain-primary-light) 0%, var(--domain-primary) 100%)",
                                            color: "var(--domain-primary-contrast)",
                                            fontWeight: 700,
                                            fontSize: "0.875rem",
                                            textTransform: "none",
                                            px: 3,
                                            py: 1.25,
                                            borderRadius: 2.5,
                                            letterSpacing: "0.01em",
                                            boxShadow: "0 2px 12px rgba(240,172,77,0.30)",
                                            transition: "all 0.2s ease",
                                            "&:hover": {
                                                background: "linear-gradient(135deg, var(--domain-text) 0%, var(--domain-text) 100%)",
                                                boxShadow: "0 4px 20px rgba(26,37,56,0.25)",
                                                "& .MuiButton-endIcon": {
                                                    transform: "translateX(4px)"
                                                }
                                            },
                                        }}
                                    >
                                        Nachricht senden
                                    </Button>
                                </Grid>

                            </Grid>

                        </Box>
                    </Paper>
                </Grid>

                {/* Kontaktinfos */}
                <Grid item xs={12} md={5}>
                    <Paper sx={{ p: 4 }}>

                        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                            Kontaktinformationen
                        </Typography>

                        <Typography sx={{ mb: 2 }}>
                            <strong>Tourismus-Schweiz.ch GmbH</strong><br />
                            Hüttenweg 16<br />
                            CH-8254 Basadingen
                        </Typography>

                        <Typography sx={{ mb: 1 }}>
                            <strong>Telefon:</strong><br />
                            +41 (0)52 654 18 10
                        </Typography>

                        <Typography sx={{ mb: 1 }}>
                            <strong>Fax:</strong><br />
                            +41 (0)52 654 18 09
                        </Typography>

                        <Typography sx={{ mb: 1 }}>
                            <strong>E-Mail:</strong><br />
                            mail@tourismus-schweiz.ch<br />
                            mail@HRI.ch
                        </Typography>

                        <Typography>
                            <strong>Internet:</strong><br />
                            www.HRI.ch
                        </Typography>

                    </Paper>
                </Grid>

            </Grid>

        </Box>
    );
}